export const globalCoordinators = [
  { name: "Martina Lovetinska", email: "martina.lovetinska@cchellenic.com", role: "Global Coordinator" },
  { name: "Pero Pehar", email: "pero.pehar@master-fb.com", role: "Master F&B Lead" },
  { name: "Igor Guberovic", email: "igor.guberovic@cchellenic.com", role: "Global Coordinator" },
  { name: "Katarzyna Stanczak", email: "katarzyna.stanczak@cchellenic.com", role: "Global Coordinator" },
];

export const countryOwners = [
  { country: "HR", name: "Croatia", owner: "Igor Guberovic", email: "igor.guberovic@cchellenic.com" },
  { country: "BA", name: "Bosnia & Herzegovina", owner: "Igor Guberovic", email: "igor.guberovic@cchellenic.com" },
  { country: "SI", name: "Slovenia", owner: "Igor Guberovic", email: "igor.guberovic@cchellenic.com" },
  { country: "PL", name: "Poland", owner: "Katarzyna Stanczak", email: "katarzyna.stanczak@cchellenic.com" },
  { country: "RO", name: "Romania", owner: "Cosmin Murarescu", email: "cosmin.murarescu@cchellenic.com" },
  { country: "AT", name: "Austria", owner: "Orcun Sacan", email: "orcun.sacan@cchellenic.com" },
  { country: "MK", name: "North Macedonia", owner: "Bojan Krstevski", email: "bojan.krstevski@cchellenic.com" },
  { country: "RS", name: "Serbia", owner: "Jovana Paljic", email: "jovana.paljic@cchellenic.com" },
  { country: "ME", name: "Montenegro", owner: "Jovana Paljic", email: "jovana.paljic@cchellenic.com" },
  { country: "XK", name: "Kosovo", owner: "Jovana Paljic", email: "jovana.paljic@cchellenic.com" },
  { country: "AM", name: "Armenia", owner: "Victor Besaraba", email: "victor.besaraba@cchellenic.com" },
  { country: "MD", name: "Moldova", owner: "Maxim Sendrea", email: "maxim.sendrea@cchellenic.com" },
];

export const getOwnerByCountry = (code) =>
  countryOwners.find((c) => c.country === code);
